<template>
  <!-- Modal -->
  <Modal
    id="edit-tag-modal"
    title="Modifica Tag"
    :submit-btn-disabled="loading || duplicateTag"
    @submit="save()"
  >
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border" role="status" aria-hidden="true">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div>
        <label>
          Nome tag:
          <input
            id="tag-name"
            type="text"
            class="form-control"
            v-model="name"
          />
          <p v-if="duplicateTag" class="form-text">Questo nome è già stato utilizzato.</p>
        </label>
      </div>
      <div>
        <label>
          Annida sotto a:
          <select class="form-control" v-model="parent">
            <option value="">Nessuno</option>
            <option v-for="tag in tags" :value="tag.id">{{tag.display}}</option>
          </select>
        </label>
      </div>
    </div>
    
    <template #footer>
      <input 
        type="button" 
        class="btn btn-danger" 
        data-bs-dismiss="modal"
        value="Elimina"
        :disabled="tag?.children?.length > 0 ?? true"
        @click="showModal('delete-tag-modal', accountId, tag)"
      >
    </template>
  </Modal>
</template>

<script setup>
import bus from '@/bus.js';
import { ref, onBeforeUnmount, watch, inject } from 'vue';
import * as tagService from '@/services/tag.service.js';
import Modal from './Modal.vue';

const hideModal = inject('hideModal');
const showModal = inject('showModal');

const name = ref('');
const parent = ref('');
const tags = ref(null);
const tag = ref(null);
const accountId = ref('');
const loading = ref(false);
const duplicateTag = ref(false);

function isDuplicateTag(name) {
  return tags.value.find((t) => t.name == name && t.id != tag.value?.id) != null;
}

async function save() {
  let parentId = null;
  if (parent.value != '') {
    parentId = parent.value;
  }

  let tagDTO = {
    id: tag.value.id,
    name: name.value,
    father_id: parentId
  }

  await tagService.update(accountId.value, tagDTO);

  bus.$emit('tagAdded', { account: accountId.value });

  hideModal('edit-tag-modal');
}

async function init(account, tagData) {
  loading.value = true;

  accountId.value = account

  const allTags = (await tagService.getAccountTags(accountId.value))
    .filter(t => t.id != tag.id);
  const tagTrees = tagService.tagListToTree(allTags);
  tags.value = tagService.flattenTagTrees(tagTrees);

  tag.value = tagData
  name.value = tagData.name
  parent.value = tagData.father_id
  
  loading.value = false;
}

// Initialize callbacks
bus.$on('init-edit-tag-modal', init);

onBeforeUnmount(() => {
  bus.$off('init-edit-tag-modal', init);
});

watch(name, (newValue) => {
  if (isDuplicateTag(newValue)) {
    duplicateTag.value = true;
  } else {
    duplicateTag.value = false;
  }
})

</script>

<style>
</style>
